import fetch from '@/utils/fetch';

var baseUrl = "/Service/Api/jd?service=JingshiService";
// 查询栏目
export function getColumnTree(param) {
    return fetch({
        url: baseUrl + '&method=getColumnTreeByRule&param=ColumnTreeByRuleParameter',
        method: 'post',
        data: param
    });
}
// 查询栏目
export function getAllColumnTree(param) {
    return fetch({
        url: baseUrl + '&method=getColumnTree&param=BaseParameter',
        method: 'post',
        data: param
    });
}
// 新建栏目
export function addColumnDTO(param) {
    return fetch({
        url: baseUrl + '&method=updateColumnDTO&param=CmsColumnParam',
        method: 'post',
        data: param
    });
}
// 编辑栏目
export function updateColumnDTO(param) {
    return fetch({
        url: baseUrl + '&method=updateColumnDTO&param=CmsColumnParam',
        method: 'post',
        data: param
    });
}

// 删除栏目
export function delColumn(param) {
    return fetch({
        url: baseUrl + '&method=delColumn&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}
// 获取栏目信息
export function getColumnDTOById(param) {
    return fetch({
        url: baseUrl + '&method=getColumnDTOById&param=CommonIdParam',
        method: 'post',
        data: param
    });
}
// 获取文章列表
export function getArticleListByCondition(param) {
    return fetch({
        url: baseUrl + '&method=getArticleListByCondition&param=GetArticleListByConditionParam',
        method: 'post',
        data: param
    });
}
// 新建文章
export function addArticleDTO(param) {
    return fetch({
        url: baseUrl + '&method=addArticleDTO&param=ArticleDTOParam',
        method: 'post',
        data: param
    });
}
// 删除
export function delArticle(param) {
    return fetch({
        url: baseUrl + '&method=delArticle&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}

export function updateProperty(param) {
    return fetch({
        url: baseUrl + '&method=updateProperty&param=UpdatePropertyParam',
        method: 'post',
        data: param
    });
}

export function check(param) {
    return fetch({
        url: baseUrl + '&method=check&param=CheckParam',
        method: 'post',
        data: param
    });
}

// 获取栏目信息
export function getArticleDTOById(param) {
    return fetch({
        url: baseUrl + '&method=getArticleDTOById&param=CommonIdParam',
        method: 'post',
        data: param
    });
}

// 获取栏目信息
export function getCommitteeListByCondition(param) {
    return fetch({
        url: baseUrl + '&method=getCommitteeListByCondition&param=CommitteeListConditionDTO',
        method: 'post',
        data: param
    });
}

// 委员会
export function addCommitteeDTO(param) {
    return fetch({
        url: baseUrl + '&method=addCommitteeDTO&param=JingshiCommitteeParam',
        method: 'post',
        data: param
    });
}

export function getCommitteeDTOById(param) {
    return fetch({
        url: baseUrl + '&method=getCommitteeDTOById&param=GetCommitteeDTOParam',
        method: 'post',
        data: param
    });
}
export function delCommittee(param) {
    return fetch({
        url: baseUrl + '&method=delCommittee&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}

//律师
export function getLawyerListByCondition(param) {
    return fetch({
        url: baseUrl + '&method=getLawyerListByCondition&param=GetLawyerListParam',
        method: 'post',
        data: param
    });
}



export function updateLawyerDTO(param) {
    return fetch({
        url: baseUrl + '&method=updateLawyerDTO&param=JingshiLawyerParam',
        method: 'post',
        data: param
    });
}
export function getLawyerDTOById(param) {
    return fetch({
        url: baseUrl + '&method=getLawyerDTOById&param=CommonIdParam',
        method: 'post',
        data: param
    });
}

export function delLawyer(param) {
    return fetch({
        url: baseUrl + '&method=delLawyer&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}

//团队
export function getTeamListByCondition(param) {
    return fetch({
        url: baseUrl + '&method=getTeamListByCondition&param=GetTeamListParam',
        method: 'post',
        data: param
    });
}

export function getTeamDTOById(param) {
    return fetch({
        url: baseUrl + '&method=getTeamDTOById&param=CommonIdParam',
        method: 'post',
        data: param
    });
}

export function updateTeamDTO(param) {
    return fetch({
        url: baseUrl + '&method=updateTeamDTO&param=JingshiTeamParam',
        method: 'post',
        data: param
    });
}

export function delTeam(param) {
    return fetch({
        url: baseUrl + '&method=delTeam&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}
export function getLawyerInfoList(param) {
    return fetch({
        url: baseUrl + '&method=getLawyerInfoList&param=LawyerInfoParam',
        method: 'post',
        data: param
    });
}
//留言
export function getLeaveMessageListByCondition(param) {
    return fetch({
        url: baseUrl + '&method=getLeaveMessageListByCondition&param=LeaveMessageListConditionDTO',
        method: 'post',
        data: param
    });
}

export function delLeaveMessage(param) {
    return fetch({
        url: baseUrl + '&method=delLeaveMessage&param=CommonIdsParam',
        method: 'post',
        data: param
    });
}
export function updateMessageStatus(param) {
    return fetch({
        url: baseUrl + '&method=updateMessageStatus&param=UpdateMessageStatusParam',
        method: 'post',
        data: param
    });
}

export function getUserLawyerTeam(param) {
    return fetch({
        url: baseUrl + '&method=getUserLawyerTeam&param=BaseParameter',
        method: 'post',
        data: param
    });
}


// WEBPACK FOOTER //
// ./src/api/jingshi.js